import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})
export class LessonPlanService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  // Activity Type
 
  GetAllActivityType(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);   
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'LessonPlan/GetAllActivityType', formData);
  }

  SaveActivityType(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);   
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'LessonPlan/SaveActivityType', formData);
  }

  ActivityTypeMarkActive(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'LessonPlan/ActivityTypeMarkActive', formData);
  }

  // Lesson Planning
 
  GetAllLessonPlan(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);   
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'LessonPlan/GetAllLessonPlan', formData);
  }

  SaveLessonPlan(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("data", data);
    formData.append("file", file);   
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'LessonPlan/SaveLessonPlan', formData);
  }

  ApproveLessonPlan(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'LessonPlan/ApproveLessonPlan', formData);
  }

   // Daily Class Planning

   GetAllDailyClassPlan(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'LessonPlan/GetAllDailyClassPlan', formData);
  }

  SaveDailyClassPlan(list,data): Observable<any> {
    let formData = new FormData();
    formData.append("objItemList", list);
    formData.append("objModel", data); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'LessonPlan/SaveDailyClassPlan', formData);
  }

  SaveActualDailyClassPlan(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'LessonPlan/SaveActualDailyClassPlan', formData);
  }

  UploadDailyClassPlan(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("strdata", data);
    formData.append("PlanList", file);   
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'LessonPlan/UploadDailyClassPlan', formData);
  }


   // Other Planning

   GetAllOtherPlan(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'LessonPlan/GetAllOtherPlan', formData);
  }

  SaveOtherPlan(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'LessonPlan/SaveOtherPlan', formData);
  }



}
